import { render, staticRenderFns } from "./SidebarLogoPreview.vue?vue&type=template&id=554308fe&"
import script from "./SidebarLogoPreview.vue?vue&type=script&lang=js&"
export * from "./SidebarLogoPreview.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLogoPreview.vue?vue&type=style&index=0&id=554308fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports